import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { supabase } from '../../core/supabase/supabase.client';

export interface AdminDashboardSummary {
  orders_today: number;
  sales_today: number;
  average_order_value: number;
  riders_online: number;
  customers: number;
  generated_at: string;
  status: {
    new_orders: number;
    preparing: number;
    delivering: number;
    delivered: number;
    cancelled: number;
  };
  chart: Array<{
    date: string;
    label: string;
    sales: number;
  }>;
  recent_orders: Array<{
    id: number;
    order_number: string | null;
    payable_amount: number;
    status: string;
    created_at: string;
    customer_name: string | null;
    store_name: string | null;
  }>;
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
  getSummary(storeId: number | null): Observable<AdminDashboardSummary> {
    return from(
      supabase
        .rpc('admin_dashboard_summary', {
          p_store_id: storeId,
          p_timezone: 'Asia/Kolkata',
        })
        .then(({ data, error }) => {
          if (error) throw error;
          return data as AdminDashboardSummary;
        })
    );
  }
}
